export default {
    noAnswer: 'No answer'
}
